import { cssProps } from '@oracle/oraclejet-cssprops';
import { useTabbableMode } from '../hooks/UNSAFE_useTabbableMode';
import { useTranslationBundle } from '../hooks/UNSAFE_useTranslationBundle';
import { BundleType } from '../resources/nls/bundle';

const rootStyles = cssProps`${{
  color: 'var(--oj-c-PRIVATE-DO-NOT-USE-link-text-color)',
  lineHeight: 'inherit',
  textDecorationLine: 'var(--oj-c-PRIVATE-DO-NOT-USE-link-text-decoration-line)',
  cursor: 'var(--oj-c-PRIVATE-DO-NOT-USE-core-cursor-clickable)',

  '&:visited': {
    color: 'var(--oj-c-PRIVATE-DO-NOT-USE-link-text-color-visited)'
  },

  '&:active': {
    color: 'var(--oj-c-PRIVATE-DO-NOT-USE-link-text-color-active)'
  },

  '&:hover': {
    textDecorationLine: 'var(--oj-c-PRIVATE-DO-NOT-USE-link-text-decoration-line-hover)',

    transitionProperty: 'text-decoration',
    transitionDuration: 'var(--oj-c-PRIVATE-DO-NOT-USE-animation-duration-long)'
  },

  // TODO: use cross-browser supported focus strategy
  '&:focus-visible': {
    outlineColor: 'var(--oj-c-PRIVATE-DO-NOT-USE-core-focus-border-color)',
    outlineStyle: 'dotted',
    outlineWidth: '1px',
    outlineOffset: '-1px'
  }
}}`;

type Props = {
  children?: string;
  source: string;
};

export function InlineHelpSource({ children, source }: Props) {
  const translations = useTranslationBundle<BundleType>('@oracle/oraclejet-preact');
  const userAssistance_learnMoreStr = translations.userAssistance_learnMore();
  children = children ?? userAssistance_learnMoreStr;
  // JET-52914 - Implement Tabbable mode API contract in InputText
  // if not tabbable, spread tabbableModeProps on component
  const { isTabbable, tabbableModeProps } = useTabbableMode();
  // TODO: Implement and use a preact Link component instead of using an anchor tag
  return (
    <a class={rootStyles} target="_blank" href={source} {...(!isTabbable && tabbableModeProps)}>
      {children}
    </a>
  );
}
